export enum KnmVersionsEnum {
  ERP = 'ERP',
  ERKNM = 'ERKNM',
  ALL = 'ALL',
}
